import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import { GlobalService } from '../services/global.service';
import { SidebarService } from '../services/sidebar.service';
import { ModalService } from '../shared/modal/modal.service';
import { SnackBarService } from '../shared/snackbar/snackbar.service';
import { LoadingService } from '../shared/loading/loading.service';

import { of, timer, Subject } from 'rxjs';
import { debounce, debounceTime } from 'rxjs/operators';


import Util from '../shared/utility';

import { Options } from 'ng5-slider';

@Component({
    selector: 'app-medicare-means-testing',
    templateUrl: './medicare-means-testing-v2.component.html',
    styleUrls: ['./medicare-means-testing-v2.component.css']
})
export class MedicareMeansTestingComponentV2 implements OnInit {
    public client: any;

    public areaChartData: any[];
    public highestBracketExpense: number;

    public clientBenefit: string = null;
    public spouseBenefit: string = null;

    public surcharges: string = '$0';
    public medicarePremiums: string = '$0';
    public totalMedicareCost: string = '$0';
    public totalSavings: string = '$0';
    public incomeReductionAmount: string = '$0';
    
    public isAlreadyInitializeComponent: boolean = false;
    public startingSurchargeAmount: number = -1;
    public startingIllustration: any[];

    retirementPlanningForm: FormGroup;
    clonedRetirementPlanningForm: any;

    public magiMessage: string = "Reducing your projected MAGI (Modified Adjusted Gross Income) may lower or eliminate future surcharges. Allocating future income towards product that does not impact MAGI may result in significant savings.";
    public ssbMessage: string = "Your actual monthly benefit in the first year you collect Social Security. Note: This will likely vary from your Primary Insurance Amount (PIA) as it includes future cost-of-living adjustments (COLAs) and changes to your benefit amount based on claim age.";

    public rOROptions: any[] = [
        {
          text: 'Option 1',
          value: '2020'
        },
        {
          text: 'Option 2',
          value: '2021',
          selected: true
        },
        {
          text: 'Option 3',
          value: '2022'
        },
        {
          text: 'Option 4',
          value: '2023'
        },
        {
          text: 'Option 5',
          value: '2024'
        },
        {
          text: 'Option 6',
          value: '2025'
        },
        {
          text: 'Option 7',
          value: '2026'
        },
        {
          text: 'Option 8',
          value: '2027'
        }
      ];

    public doughnutChartData = [];
    public mmtData: any;

    public magi: number = 100;

    public sliderOptions: Options = {
        floor: 0,
        ceil: 100,
        animate: false,
        showSelectionBar: true,
        translate: (value: number): string => (value + '%')
    }

    public doughnutChartSettings = {
        view: [400, 400],
        colorScheme: { domain: ['#20a59f', '#3385C5'] },
        showLegend: true,
        explodeSlices: true,
        showLabels: false,
        doughnut: true,
        gradient: false,
        maxYAxisTickLength: 16,
        maxXAxisTickLength: 16,
        arcWidth: 0.4,
        tooltipText: (data) => {
            return this.formatCurrency(data.value);
        }
    }

    public areaChartSettings = {
        showXAxis: false,
        showYAxis: true,
        gradient: false,
        showLegend: true,
        showXAxisLabel: false,
        xAxisLabel: '',
        showYAxisLabel: false,
        yAxisLabel: '',
        showGridLines: false,
        colorScheme: { domain: ['#047388', '#A5A5A5', '#9CE6E5', '#3385C5', '#20a59f', '#0B4C8E'] },
        autoScale: false,
    }

    public lineChartSettings = {
        showXAxis: true,
        showYAxis: false,
        gradient: false,
        showLegend: false,
        showXAxisLabel: false,
        xAxisLabel: '',
        showYAxisLabel: false,
        yAxisLabel: '',
        showGridLines: true,
        colorScheme: { domain: ['#ffffff'] },
        autoScale: false,
    }

    public mmtModalData: any;

    public ssClientAge: string = '65';
    public ssSpouseAge: string = '65';
    public ssClientAgeChanged: Subject<string> = new Subject<string>();
    public ssSpouseAgeChanged: Subject<string> = new Subject<string>();

    clientRetirementAgeMin = 62;
    spouseRetirementAgeMin = 62;

    imgSrc: string;
    isSrcReport: string;

    constructor(public sidebarService: SidebarService, public globalService: GlobalService, public modalService: ModalService, public snackBarService: SnackBarService, public router: Router, public loadingService: LoadingService) {
        this.imgSrc = '../../../assets/icons/mmt_illustration.svg';
        this.isSrcReport = "meansTestingReport";
        modalService.modal$.subscribe((modal) => {
            if (modal.modalName == 'add-edit-clientClosed') { // TODO: Fix this hack -- naming it hidden.. modals in general need to be refactored
                this.magi = 100;
                this.isSliding = false;
                this.startingSurchargeAmount = -1;

                this.getClient();
            }
        });

        sidebarService.clientUpdated.subscribe(() => {
            if (this.isAlreadyInitializeComponent) {
                this.router.navigate(['/clients/edit/medicare-means-testing/options/mmtv2']);
            }

        })

        this.router.routeReuseStrategy.shouldReuseRoute = () => {
            return false;
        };

        this.ssClientAgeChanged.pipe(
            debounceTime(1500))
            .subscribe(model => {
                this.magi = 100;
                this.ssClientAge = this.validateSSAge(Number(this.ssClientAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
                this.getMMTData();
            });

        this.ssSpouseAgeChanged.pipe(
            debounceTime(1500))
            .subscribe(model => {
                this.magi = 100;
                this.ssSpouseAge = this.validateSSAge(Number(this.ssSpouseAge), this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed');
                this.getMMTData();
            });
    }

    clampClientAge() {
        const isWidowed = this.client
            && this.client.clientProfile.Spouses.length
            && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed';
        const min = isWidowed ? 60 : this.clientRetirementAgeMin;
        const max = 70;

        let age = parseInt(this.ssClientAge as any, 10);
        if (isNaN(age) || age < min) {
            age = min;
        } else if (age > max) {
            age = max;
        }

        const clamped = age.toString();
        if (this.ssClientAge !== clamped) {
            this.ssClientAge = clamped;
            this.retirementPlanningForm.get('clientAge').setValue(age);
            this.getData();
        }
    }

    clampSpouseAge() {
        const isWidowed = this.client
            && this.client.clientProfile.Spouses.length
            && this.client.clientProfile.Spouses[0].maritalStatus == 'Widowed';
        const min = isWidowed ? 60 : this.spouseRetirementAgeMin;
        const max = 70;

        let age = parseInt(this.ssSpouseAge as any, 10);
        if (isNaN(age) || age < min) {
            age = min;
        } else if (age > max) {
            age = max;
        }

        const clamped = age.toString();
        if (this.ssSpouseAge !== clamped) {
            this.ssSpouseAge = clamped;
            this.retirementPlanningForm.get('spouseAge').setValue(age);
            this.getData();
        }
    }

    validateSSAge(age, survivor) {
        if (!survivor) {
            if (age < 62)
                return '62';
            if (age > 70)
                return '70';
        } else {
            if (age < 60)
                return '60';
            if (age > 70)
                return '70';
        }
        return age.toString();
    }

    changedClientSSAge(text: string) {
        this.startingSurchargeAmount = -1;
        this.ssClientAgeChanged.next(text);
    }

    changedSpouseSSAge(text: string) {
        this.startingSurchargeAmount = -1;
        this.ssSpouseAgeChanged.next(text);
    }


    ngOnInit() {
        this.retirementPlanningForm = new FormGroup({
            clientAge: new FormControl(parseInt(this.ssClientAge), [Validators.min(62), Validators.max(70)]),
            spouseAge: new FormControl(parseInt(this.ssSpouseAge), [Validators.min(62), Validators.max(70)]),
            irr: new FormControl(),
            rateOfReturnYear: new FormControl(),
            inflation: new FormControl()
        });

        this.getClient();
        this.isAlreadyInitializeComponent = true;
    }
    
    readjustRetirementPlanningForm(){
        if(this.client){
            this.clientRetirementAgeMin = this.client.clientProfile.RetirementAge < 62 ? 62
            : this.client.clientProfile.RetirementAge >= 63 && this.client.clientProfile.RetirementAge <= 69 ? this.client.clientProfile.RetirementAge
                : 70;
                
            this.retirementPlanningForm.get('clientAge').setValidators([Validators.required, Validators.min(this.clientRetirementAgeMin), Validators.max(70)]);
            this.retirementPlanningForm.get('clientAge').updateValueAndValidity();

            if (this.client.clientProfile.Spouses) {
                if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                    this.spouseRetirementAgeMin = this.client.clientProfile.Spouses[0].retirementAge < 62 ? 62
                    : this.client.clientProfile.Spouses[0].retirementAge >= 63 && this.client.clientProfile.Spouses[0].retirementAge <= 69 ? this.client.clientProfile.Spouses[0].retirementAge
                        : 70;

                    this.retirementPlanningForm.get('spouseAge').setValidators([Validators.required, Validators.min(this.spouseRetirementAgeMin), Validators.max(70)]);
                    this.retirementPlanningForm.get('spouseAge').updateValueAndValidity();
                }
            }
        }
    }

    getData() {
        if(this.retirementPlanningForm.valid){
            //clone the form after each valid transaction
            this.clonedRetirementPlanningForm = { ...this.retirementPlanningForm.value };
            console.log('this.clonedRetirementPlanningForm', this.clonedRetirementPlanningForm);
            this.getMMTData();
        }
    }

    getMMTData() {

        if (this.client.clientProfile.InflationRate == null) {
            this.client.clientProfile.InflationRate = 3;
            this.client.clientProfile.InRetirementInflationRate = 2.4;
        }

        var tempReportVals = {
            InflationRate:  (this.client.clientProfile.InflationRate) ? this.client.clientProfile.InflationRate / 100 : 0.03,
            MagiIncomePercent: this.magi,
            IncludePartner: this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married',
            SocialSecurityRetirementAge: this.ssClientAge,
            SSMonthlyBenefit: this.client.clientProfile.PIA,
            PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? Number(this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "")) || 0 : this.client.clientProfile.Spouses[0] ? Number(this.client.clientProfile.Spouses[0].pia) || 0 : 0,
            PartnerSocialSecurityAge: this.ssSpouseAge
        }
        
        var user = {
            UserID: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorID') : localStorage.getItem('userId'),
            CompanyCode: Number(localStorage.getItem('roleId')) <= 2 ? localStorage.getItem('selectedAdvisorOrgID') : localStorage.getItem('orgID'),
            ClientID: localStorage.getItem('selectedClient')
        }
        
        if ((Number(this.ssClientAge) >= 60 || Number(this.ssClientAge) <= 70) && (Number(this.ssSpouseAge) >= 60 || Number(this.ssSpouseAge) <= 70)) {

            this.globalService.getMMTData(this.client, tempReportVals, user, true)
                .subscribe(
                    data => {
                        console.log('MMT data', data);
                        this.createIRMAAAreaChartData(data);
                        this.createIRMAALineChartData(data);
                        this.calculateTotals(data);
                        
                        const proratedClientMonths = 12 - this.client.client.DOB.split('/')[0] + 1;
                        this.clientBenefit = Util.formatToCurrency(Number(data.clientSSBenfit / proratedClientMonths).toFixed(0) || 0);

                        const proratedSpouseMonths = this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married' ? 12 - this.client.clientProfile.Spouses[0].dob.split('/')[0] + 1 : 12;
                        this.spouseBenefit = Util.formatToCurrency(Number(data.spouseSSBenefit / proratedSpouseMonths).toFixed(0) || 0);

                        this.mmtModalData = data.IllustrationEntries.map((entry, idx) => {
                          if (entry.ClientAge >= data.Client.RetirementAge || (entry.PartnerAge && entry.PartnerAge >= data.Partner.RetirementAge)) {
                                this.mmtData = data;

                                entry.ClientAge = entry.ClientAge < this.client.clientProfile.RetirementAge ? '--' : entry.ClientAge;

                                if (entry.PartnerAge)
                                    entry.PartnerAge = entry.PartnerAge < this.client.clientProfile.Spouses[0].retirementAge ? '--' : entry.PartnerAge;

                                let updatedEntry = {
                                    yearWithAge: entry.PartnerAge ? `${entry.Year}(${entry.ClientAge}/${entry.PartnerAge})` : `${entry.Year}(${entry.ClientAge})`,
                                    magi: this.magi,
                                    fullMAGI: this.formatCurrency(entry.HouseholdIncome),
                                    percentMAGI: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                                    updatedBracket: entry.MagiAdjustedIncomeBracket,
                                    premiums: this.formatCurrency(entry.HouseholdExpenseByBracket[0]),
                                    surcharges: this.formatCurrency(entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]),
                                    total: entry.MagiAdjustedIncomeBracket === 1 ? entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] : entry.HouseholdExpenseByBracket[0] + entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0],
                                    savings: this.formatCurrency(Math.max(0, Math.abs((entry.MagiAdjustedIncomeBracket === 1 ? 0 : entry.HouseholdExpenseByBracket[entry.MagiAdjustedIncomeBracket - 1] - entry.HouseholdExpenseByBracket[0]) - (this.startingIllustration[idx].MagiAdjustedIncomeBracket === 1 ? 0 : this.startingIllustration[idx].HouseholdExpenseByBracket[this.startingIllustration[idx].MagiAdjustedIncomeBracket - 1] - this.startingIllustration[idx].HouseholdExpenseByBracket[0]))))
                                }

                                updatedEntry.total = this.formatCurrency(updatedEntry.total);
                                return updatedEntry;
                            }
                        });

                        const totalPremiums = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.premiums) } else { return r }}, 0));
                        const totalSurcharges = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.surcharges); } else { return r }}, 0));
                        const total = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.total) } else { return r }}, 0));
                        const savings = this.formatCurrency(this.mmtModalData.reduce( (r, e) => { if (e) { return r + Util.removeCurrencyFormatting(e.savings) } else { return r }}, 0));

                        console.log('totalSurcharges', totalSurcharges);

                        this.mmtModalData.push({
                            yearWithAge: 'Total',
                            magi: '',
                            fullMAGI: '',
                            percentMAGI: '',
                            updatedBracket: '',
                            premiums: totalPremiums,
                            surcharges: totalSurcharges,
                            total: total,
                            savings: savings,
                        })

                        this.mmtModalData = this.mmtModalData.filter((item) => {return item != undefined});
                        this.isSliding = false;
                    },
                    error => console.log(error));

                    this.loadingService.isLoading(false);
        }
    }

    calculateTotals(data: any) {
        var ts = 0, tp = 0, tm = 0, tss = 0;
        var savings = 0;

        for (var ageRange in data.MagiAdjustedAgeRangeCosts) {
            tp += data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount;
            ts += (data.MagiAdjustedAgeRangeCosts[ageRange].Amount - data.MagiAdjustedAgeRangeCosts[ageRange].Bracket1Amount);
            tm += data.MagiAdjustedAgeRangeCosts[ageRange].Amount;
        }

        if (this.startingSurchargeAmount === -1 || this.changedSSAge) {
            this.startingSurchargeAmount = ts;
            this.startingIllustration = data.IllustrationEntries;
            this.changedSSAge = false;
        }
        else
            savings = Math.max(0, this.startingSurchargeAmount - ts);
        
        this.medicarePremiums = this.formatCurrency(tp);
        this.surcharges = this.formatCurrency(ts);
        this.totalMedicareCost = this.formatCurrency(tm);

        this.doughnutChartData = [
            {
                "name": tm == tp ? ' ' : 'Surcharge Savings',
                "value": savings,
            },
            {
                "name": tm == tp ? 'Premiums' : 'Remaining Surcharges',
                "value": Math.max(0, tm == tp ? tp : tm - tp),
            },
        ];

        this.totalSavings = this.formatCurrency(savings);
    }

    getClient() {
        this.globalService.getClientData(Number(localStorage.getItem("selectedClient")), 4)
            .subscribe(
                client => {
                    this.client = client;
                    this.magi = this.client.clientProfile.MAGIPercentIncome || 100;

                    if (!this.client.clientProfile.SSDesiredAgeYears) {
                        this.ssClientAge = this.client.clientProfile.RetirementAge < 62 ? 62
                        : this.client.clientProfile.RetirementAge >= 63 && this.client.clientProfile.RetirementAge <= 69 ? this.client.clientProfile.RetirementAge
                            : 70
                    } else {
                        this.ssClientAge = this.client.clientProfile.SSDesiredAgeYears;
                    }

                    if (this.client.clientProfile.Spouses) {
                        this.client.clientProfile.Spouses = JSON.parse(this.client.clientProfile.Spouses);
                        
                        if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married' && !this.client.clientProfile.Spouses[0].sSDesiredAgeYears) {
                            this.ssSpouseAge = this.client.clientProfile.Spouses[0].retirementAge < 62 ? 62
                                : this.client.clientProfile.Spouses[0].retirementAge >= 63 && this.client.clientProfile.Spouses[0].retirementAge <= 69 ? this.client.clientProfile.Spouses[0].retirementAge
                                    : 70
                        } else if (this.client.clientProfile.Spouses[0].maritalStatus == 'Married') {
                            this.ssSpouseAge = this.client.clientProfile.Spouses[0].sSDesiredAgeYears;
                            if (!this.client.clientProfile.SSDesiredAgeYears) {
                                this.ssClientAge = this.ssSpouseAge;
                                this.client.clientProfile.SSDesiredAgeYears = this.ssSpouseAge;
                            }
                        }
                    }

                    this.loadingService.isLoading(true);

                    const currentYear = new Date().getFullYear();
                    let isMarried = this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married';
                    let periods = Math.min(this.client.clientProfile.RetirementAge - Util.calculateAge(new Date(this.client.client.DOB), new Date()));

                    if (isMarried)
                        periods = Math.min(periods, Math.min(this.client.clientProfile.Spouses[0].retirementAge - Util.calculateAge(new Date(this.client.clientProfile.Spouses[0].dob), new Date())));

                    if (this.client.clientProfile.CurrentIncome === null) {
                        this.globalService.getMMTBracket(this.client.clientProfile.Spouses && this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married', currentYear)
                            .subscribe(
                                bracketData => {
                                    if(this.client.clientProfile.Bracket){
                                        //brackets
                                        const brackets = [bracketData.Bracket1, bracketData.Bracket2, bracketData.Bracket3, bracketData.Bracket4, bracketData.Bracket5, bracketData.Bracket6]
                                        const bracketIncome = this.client.clientProfile.Bracket == 1 ? brackets[1] / 2
                                        : this.client.clientProfile.Bracket == 6 ?  brackets[5] : (brackets[this.client.clientProfile.Bracket - 1] + brackets[this.client.clientProfile.Bracket]) / 2;

                                        this.client.clientProfile.CurrentIncome = bracketIncome;
                                    } else {
                                        //household income
                                        this.client.clientProfile.CurrentIncome = this.client.clientProfile.HouseholdYearOneIncome;
                                    }

                                    for (var i = 1; i <= periods; i++) {
                                        this.client.clientProfile.CurrentIncome = this.client.clientProfile.CurrentIncome + (this.client.clientProfile.CurrentIncome * 0.03);
                                    }

                                    if (isMarried) {
                                        this.client.clientProfile.Spouses[0].currentIncome = this.client.clientProfile.CurrentIncome / 2;
                                        this.client.clientProfile.CurrentIncome = this.client.clientProfile.CurrentIncome / 2;
                                    }

                                    console.log('what is this.client.clientProfile.CurrentIncome', this.client.clientProfile.CurrentIncome);
                                    if (this.client.clientProfile.PIA === null) {
                                        this.globalService.getPIA(this.generatePIAObject(this.client.clientProfile.CurrentIncome / 2)).subscribe(
                                            piaData => {
                                                this.client.clientProfile.PIA = piaData;

                                                if (isMarried && this.client.clientProfile.Spouses[0].pia == null)
                                                    this.client.clientProfile.Spouses[0].pia = piaData;

                                                this.getMMTData();
                                            }
                                        );
                                    } else {
                                        this.getMMTData();
                                    }
                                },
                                error => console.log(error));
                    } else {
                        if (isMarried) {
                            if(this.client.clientProfile.Spouses[0].currentIncome){
                                //Portal1 backwards compatability add/fix
                                this.client.clientProfile.Spouses[0].currentIncome = parseInt(this.client.clientProfile.Spouses[0].currentIncome);                                
                            }
                        }

                        this.getMMTData();
                    }

                    //this.readjustRetirementPlanningForm();
                },
                error => console.log(error));
    }

    // Since we need to generate a PIA w little client info we need to make assumptions
    // Each person using this object will get 30 years of earning history
    // We use bracket data for income and a mock earning history to determine PIA
    generatePIAObject(income) {
        let result = [];
        const totalYears = 30;
        const currentYear = new Date().getFullYear();

        for (let i = 0; i < totalYears; i++) {
            result.push({
                Year: currentYear - totalYears + i,
                ActualEarnings: income,
                MaxEarnings: 0,
                WeightedEarnings: 0,
                Age: totalYears + i
            })
        }

        return {
            currentAge: 62,
            earningYear: result
        }
    }

    formatCurrency(val) {
        return '$' + val.toLocaleString();
    }

    createIRMAALineChartData(data: any) {
        const expenseYears = data.IllustrationEntries.filter((entry) => entry.HouseholdExpenseByBracket[0]);

        const lineChartData = [
            {
                name: 'Income',
                color: '#ffffff',
                series: expenseYears.map((entry) => {
                    return {
                        name: entry.Year.toString(),
                        value: entry.MagiAdjustedHouseholdIncome,
                        houseHoldIncome: this.formatCurrency(entry.MagiAdjustedHouseholdIncome),
                        clientAge: entry.ClientAge,
                        partnerAge: entry.PartnerAge ? entry.PartnerAge : 'x',
                        bracket: this.formatBracketMinimal(entry.MagiAdjustedIncomeBracket),
                        bracketHigh: this.areaChartData.reduce((result, item, i) => {
                            if (i < entry.MagiAdjustedIncomeBracket) {
                                result += item.series.reduce((r, e) => {
                                    if (entry.Year == e.name)
                                        r = e.value;
                                    return r
                                }, 0);
                            }
                            return result;
                        }, 0),
                        bracketLow: entry.MagiAdjustedIncomeBracket == 1 ? 0 : this.areaChartData.reduce((result, item, i) => {
                            if (i < entry.MagiAdjustedIncomeBracket - 1) {
                                result += item.series.reduce((r, e) => {
                                    if (entry.Year == e.name){
                                        r = e.value;
                                    }
                                    return r
                                }, 0);
                            }
                            return result;
                        }, 0),
                    }
                })
            }
        ]

        const highestBracketExpense = this.areaChartData.reduce((result, bracket) => {
            let sum = 0;

            this.areaChartData.forEach(b => {
                if (b.series[b.series.length - 1])
                    sum += b.series[b.series.length - 1].value
            });

            if (result < sum)
                result = sum;

            return result;
        }, 0);

        this.lineChartSettings['yScaleMax'] = highestBracketExpense; //this.areaChartSettings['yScaleMax'];
        this.lineChartSettings['yScaleMin'] = 0;

        Object.assign(this, { lineChartData });
    }

    createIRMAAAreaChartData(data: any) {
        const areaChartData = [
            {
                name: 'Bracket 1',
                color: '#047388',
                series: data.NgxBracketCosts.Bracket1
            },
            {
                name: 'Bracket 2',
                color: '#A5A5A5',
                series: data.NgxBracketCosts.Bracket2
            },
            {
                name: 'Bracket 3',
                color: '#9CE6E5',
                series: data.NgxBracketCosts.Bracket3
            },
            {
                name: 'Bracket 4',
                color: '#3385C5',
                series: data.NgxBracketCosts.Bracket4
            },
            {
                name: 'Bracket 5',
                color: '#20a59f',
                series: data.NgxBracketCosts.Bracket5
            },
            {
                name: 'Bracket 6',
                color: '#0B4C8E',
                series: data.NgxBracketCosts.Bracket6
            }
        ]

        Object.assign(this, { areaChartData });
    }

    formatBracketMinimal(bracket: Number) {
        var affix = '';
        if (bracket === 1) {
            affix = '1st';
        } else if (bracket === 2) {
            affix = '2nd';
        } else if (bracket === 3) {
            affix = '3rd';
        } else if (bracket === 4) {
            affix = '4th';
        } else if (bracket === 5) {
            affix = '5th';
        } else {
            affix = '6th';
        }
        return affix;
    }

    public isSliding: Boolean = false;

    sliderValueChanged(e) {    
        
        this.isSliding = true;
       
    }

    sliderChangeEnd(e) {
        
        this.isSliding = false;
        this.getMMTData();
    }

    handleEditClientModal(e) {
        //this.modalService.add('add-edit-client', { ID: this.client.client.ID });
        this.router.navigate(['/clients/edit']);
    }

    public changedSSAge:boolean = false;

    ssStartAgeChange(e, isClient) {
        if (isClient) {
            this.ssClientAge = e.target.value;
        } else {
            this.ssSpouseAge = e.target.value;
        }

        this.magi = 100;
        this.changedSSAge = true;
        this.getMMTData();
    }

    handleProjectionModal(modal) {
        this.modalService.add('mmt-projections', { mmtModalData: this.mmtModalData });
    }

    handleSaveAndDownloadReport() {
        var Report = {
          ClientID: this.client.client.ID,
          AdvisorID: this.client.client.AdvisorID,
          CompanyCode: this.client.client.OrganizationID,
          ReportTypeID: 2,
        }

        let partnerActive = this.client.clientProfile.Spouses.length && this.client.clientProfile.Spouses[0].maritalStatus == 'Married';
    
        var ReportMMT = {
          ClientSSMonthlyBenefit: this.client.clientProfile.PIA,
          //this.client.clientProfile.InRetirementInflationRate
          InflationRate: (this.client.clientProfile.InflationRate) ? this.client.clientProfile.InflationRate / 100 : 0.03,
          MagiIncomePercent: this.magi,
          IncludePartner: partnerActive,
          SurvivorIncomeReductionRate: 44,
          RetirementIncomeReduction: '',
          IncomeReductionAge: '',
          IncomeReductionInflationRate: '',
          ClientSocialSecurityAge: (this.retirementPlanningForm.valid) ? this.retirementPlanningForm.value.clientAge : this.clonedRetirementPlanningForm.clientAge,// this.ssClientAge,
          ClientPensionSurvivorBenefitPercent: 0,
          ClientLifeExpectancy: this.mmtData.Client.LifeExpectancy,
          PartnerSocialSecurityAge: (this.retirementPlanningForm.valid) ? this.retirementPlanningForm.value.spouseAge : this.clonedRetirementPlanningForm.spouseAge,//this.ssSpouseAge,
          PartnerSSMonthlyBenefit: this.client.clientProfile.Spouses[0] && typeof this.client.clientProfile.Spouses[0].pia === 'string' ? this.client.clientProfile.Spouses[0].pia.replace(/,/g, "").replace("$", "") || 0 : this.client.clientProfile.Spouses[0] ? this.client.clientProfile.Spouses[0].pia || 0 : 0,
          PartnerPensionSurvivorBenefitPercent: 0,
          PartnerLifeExpectancy: this.mmtData.Partner ? this.mmtData.Partner.LifeExpectancy : 0,
          ClientCurrentAge: this.mmtData.Client.CurrentAge,
          ClientCurrentIncome: this.client.clientProfile.CurrentIncome,
          ClientGender: this.mmtData.Client.Gender,
          ClientHealthRating: this.mmtData.Client.HealthRating,
          ClientPensionAmount: this.mmtData.Client.PensionAmount,
          ClientRetirementAge: this.mmtData.Client.RetirementAge,
          FrmName0: this.client.client.FirstName + " " + this.client.client.LastName,
          FrmName1: this.mmtData.Partner ? this.client.clientProfile.Spouses[0].firstName + " " + this.client.clientProfile.Spouses[0].lastName : "",
          PartnerCurrentAge: this.mmtData.Partner ? this.mmtData.Partner.CurrentAge : 0,
          PartnerCurrentIncome: this.mmtData.Partner ? this.client.clientProfile.Spouses[0].currentIncome : 0,//this.mmtData.Partner.CurrentIncome : 0,
          PartnerGender: this.mmtData.Partner ? this.mmtData.Partner.Gender : 0,
          PartnerHealthRating: this.mmtData.Partner ? this.mmtData.Partner.HealthRating : 0,
          PartnerPensionAmount: this.mmtData.Partner ? this.mmtData.Partner.PensionAmount : 0,
          PartnerRetirementAge: this.mmtData.Partner ? this.mmtData.Partner.RetirementAge : 0,
          ReplacementRate: this.client.clientProfile.IRR || 75,
          State: this.client.clientProfile.RetirementState,
          SurchargeSavings: Util.removeCurrencyFormatting(this.totalSavings),

          MAGI: (this.client.clientProfile.MAGIPercentIncome == null) ? 100 : this.client.clientProfile.MAGIPercentIncome,
          MidRetAdjYear: this.client.midRetirementAdj ? this.client.midRetirementAdj.Year : 0,
          MidRetRedPer:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionPerc : 0,/// 100 : 0,
          MidRetRedDollar:  this.client.midRetirementAdj ? this.client.midRetirementAdj.ReductionDollar : 0,
          MidRetIncomeInflationRate: this.client.midRetirementAdj ? (this.client.midRetirementAdj.IncomeInflationRate) : 0,// / 100 : 0, 
        }
    
        this.globalService.createReport(Report, ReportMMT)
          .subscribe(
          resp => {
            this.snackBarService.add("Please wait while your medicare means testing report is being generated.", 0);
            this.downloadReport(resp.ReportID, resp.AdvisorID, resp.ClientID, resp.CompanyCode, resp.ReportTypeID);
          },
          error => { console.log(error) });
      }

      downloadReport(reportID, advisorID, clientID, orgID, reportTypeID) {
        this.loadingService.isLoading(true);
        var ReportFields = { reportID, advisorID, clientID, orgID, ReportTypeID: reportTypeID, token: localStorage.getItem("bearer") };
    
        this.globalService.generateReport(ReportFields, this.client.client, ReportFields)
          .subscribe(
          resp => {
            this.loadingService.isLoading(false);
          },
          error => { this.loadingService.isLoading(false);});
      }

      formatName() {
        if (this.client) {
          return this.client.clientProfile && this.client.clientProfile.Spouses[0] && this.client.clientProfile.Spouses[0].firstName ?
            this.client.client.FirstName + ' and ' + this.client.clientProfile.Spouses[0].firstName + ' ' + this.client.client.LastName
            : this.client.client.FirstName + ' ' + this.client.client.LastName
        }
      }

      clientHubRedirect(){
        this.router.navigate(['/clients/edit']);
      }
}
